import { type ManagedBalanceLedger } from '../state/Radom'
import { assetLineFor, networkName } from './AssetLabels'
import { getMethod } from './Managed'

/** The ticker a ledger entry is denominated in: the unified asset, or the network row's asset. */
export const ledgerTicker = (entry: ManagedBalanceLedger): string =>
  (entry.unified && entry.asset) || getMethod(entry.network, entry.token).ticker

/** Where a ledger entry's balance lives, for the line under the amount. */
export const ledgerScope = (entry: ManagedBalanceLedger): string =>
  entry.unified ? 'All networks' : `on ${networkName(entry.network)}`

/** The balance a ledger entry moved, named in full: "USDC on Polygon", or "USDC · All networks" for a pooled one. */
export const ledgerBalanceLabel = (entry: ManagedBalanceLedger, ticker: string): string =>
  entry.unified ? `${ticker} · All networks` : assetLineFor(ticker, entry.network)
